var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_327)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2963_327)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34035 0H0V2.66667L19.6469 16L22 16V13.3333L2.34035 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.780579 0L22 14.4378V16H21.2377L0 1.54726V0H0.780579Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9048 0H22V2.66667C22 2.66667 8.39122 11.5499 2.09524 16H0V13.3333L19.9048 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0H21.2895L0 14.4502V16H0.780579L22 1.55895V0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00075 0H14.0176V4.93527H22V11.0615H14.0176V16H8.00075V11.0615H0V4.93527H8.00075V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26316 0H12.7368V6.15385H22V9.84615H12.7368V16H9.26316V9.84615H0V6.15385H9.26316V0Z",
    fill: "#F93939"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    stroke: "#CECECE",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2963_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUk);
export default __webpack_public_path__ + "static/media/flag-uk.c472ee46.svg";
export { ForwardRef as ReactComponent };